package empiresmp.feature.shop.bridge

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.serialization.KSerializer
import kotlinx.serialization.serializer

internal interface TelegramBridge {
    fun close()

    fun <T> sendData(serializer: KSerializer<T>, data: T)

    companion object {
        val stateFlow = MutableStateFlow<TelegramBridge>(TelegramBridgeNoOp)
    }
}

internal inline fun <reified T> TelegramBridge.sendData(data: T) {
    sendData(serializer<T>(), data)
}
